const LOGIN_EN = Object.freeze({
    'login.title': 'Sign In to<br/>Your Qupital<br/>Funder Account',
    'login.content': 'Welcome back! Please login to your account',
    'forgot-password.title': 'Forgot<br/> Password',
    'forgot-password.content': "Enter your e-mail address and we'll send you a link to reset your password.",
    'reset-password.title': 'Set Up Your<br/> New Password',
    'reset-password.content': "What would you like your new password to be?",
    'reset-password': 'New Password',
    'current-password': 'Current Password',
    'reset-password.confirm': 'Confirm New Password',
    'reset-password.error.password-not-match': 'Password not match',
    'reset-password.error.password-too-short': 'Password too short',
    'login.login': 'Sign In',
    'login.forgot-password': 'Forgot Password',
    'login.forgot-password.email-sent': 'Email sent',
    'login.email': 'Email',
    'login.password': 'Password',
});

const LOGIN_ZH_TW = Object.freeze({
    'login.title': '登入<br/>您的橋彼道<br/>投資者帳戶',
    'login.content': '歡迎回來！請登入您的帳戶',
    'forgot-password.title': '忘記<br/> 密碼',
    'forgot-password.content': "請輸入您的登入電郵。我們將會發送一封含有重置密碼鏈結的電郵至相關電郵。",
    'reset-password.title': '設定您的<br/> 新密碼',
    'reset-password.content': "您希望怎樣設定您的新密碼?",
    'reset-password': '新密碼',
    'current-password': '現在的密碼',
    'reset-password.confirm': '確認新密碼',
    'reset-password.error.password-not-match': '密碼不符',
    'reset-password.error.password-too-short': '密碼太短',
    'login.login': '登入',
    'login.forgot-password': '忘記密碼',
    'login.forgot-password.email-sent': '電郵已發送到您的郵箱。',
    'login.email': '電郵',
    'login.password': '密碼',
});

export {
    LOGIN_EN,
    LOGIN_ZH_TW
}